import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Tile, TileHeader } from "@/components/ui/tile";

export function DenseWorkspaceSpecimen({ idPrefix }: { idPrefix: string }) {
  return (
    <section className="grid gap-4" aria-labelledby={`${idPrefix}-dense-heading`} data-dense-workspace-specimen>
      <div className="grid gap-1">
        <p className="eyebrow">Dense workspaces</p>
        <h2 id={`${idPrefix}-dense-heading`} className="text-tile-title font-semibold">Readable records and reachable controls</h2>
        <p className="text-ui text-muted-foreground">The table scrolls inside its tile. Its header remains visible, and keyboard users can reach every column.</p>
      </div>
      <div className="grid gap-[var(--layout-bento-gap)] lg:grid-cols-2">
        <Tile aria-labelledby={`${idPrefix}-dense-table`} className="px-0">
          <TileHeader id={`${idPrefix}-dense-table`} as="h3" title="Recorded results" className="px-5" />
          <Table scrollLabel="Specimen recorded results" stickyHeader className="min-w-[32rem]">
            <TableHeader><TableRow><TableHead>Record</TableHead><TableHead>Assessment</TableHead><TableHead>Score</TableHead></TableRow></TableHeader>
            <TableBody>{Array.from({ length: 40 }, (_, index) => (
              <TableRow key={index}><TableCell>Student {index + 1}</TableCell><TableCell>Comparative analysis of classical commentaries</TableCell><TableCell>{80 + (index % 20)} / 100</TableCell></TableRow>
            ))}</TableBody>
          </Table>
        </Tile>
        <div className="grid content-start gap-[var(--layout-bento-gap)]">
          <Tile aria-labelledby={`${idPrefix}-dense-message`} className="gap-3">
            <TileHeader id={`${idPrefix}-dense-message`} as="h3" title="Selected notice" />
            <p className="text-ui">The reading for the next session is available in your course materials.</p>
            <p className="text-meta text-muted-foreground">Course notice · Read</p>
          </Tile>
          <Tile aria-labelledby={`${idPrefix}-dense-fields`} className="gap-3">
            <TileHeader id={`${idPrefix}-dense-fields`} as="h3" title="Contact details" />
            <Label htmlFor={`${idPrefix}-dense-phone`}>Phone</Label>
            <Input id={`${idPrefix}-dense-phone`} type="tel" placeholder="Your contact number" />
            <p className="text-meta text-muted-foreground">Specimen field. Nothing is sent or saved.</p>
          </Tile>
        </div>
      </div>
    </section>
  );
}
